// @flow
import { isEmpty, isEqual, chain, some } from 'lodash';
import { convertToApiQuery } from '@seek/seek-jobs-search-query';

const sensitiveKeys = [
  'classification',
  'subclassification',
  'daterange',
  'keywords',
  'salaryrange',
  'salarytype',
  'where',
  'worktype'
];

const defaultValues = {
  daterange: '999',
  salaryrange: '0-999999',
  salarytype: 'annual'
};

const isDefaultParam = (val: string, key: string): boolean =>
  isEqual(defaultValues[key], val);

const cleanQuery = (
  searchQuery: SearchParams,
  locale: Locale = 'AU'
): SearchParams =>
  chain(convertToApiQuery({ locale, searchQuery }))
    .pick(sensitiveKeys)
    .omitBy(isDefaultParam)
    .value();

export default (
  currentSearchQuery: SearchParams,
  savedSearches: Array<SavedSearchExperience>,
  locale: Locale
): boolean => {
  if (isEmpty(savedSearches)) {
    return false;
  }

  const cleanCurrentQuery = cleanQuery(currentSearchQuery, locale);

  return some(savedSearches, ({ query }: { query: SearchParams }) =>
    isEqual(cleanCurrentQuery, cleanQuery(query, locale))
  );
};
